
export const Theme = {
  menu: [
    'fixed min-w-[400px] z-[100] bg-white divide-gray-100 rounded-lg shadow-lg overflow-hidden',
    'dark:bg-gray-700'
  ]
};
